import { render } from "./journalManageDetail.vue?vue&type=template&id=76a47426&scoped=true"
import script from "./journalManageDetail.vue?vue&type=script&lang=js"
export * from "./journalManageDetail.vue?vue&type=script&lang=js"

import "./journalManageDetail.vue?vue&type=style&index=0&id=76a47426&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a47426"]])

export default __exports__